/*eslint-disable*/
import React from "react";
// nodejs library to set properties for components
import PropTypes from "prop-types";
// nodejs library that concatenates classes
import classNames from "classnames";
// material-ui core components
import { List, ListItem } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";

// @material-ui/icons
import Favorite from "@material-ui/icons/Favorite";
import GridItem from "components/Grid/GridItem.js";
import GridContainer from "components/Grid/GridContainer.js";
import PARAMS from "utils/PARAMS";
import RoomIcon from '@material-ui/icons/Room';
import PhoneInTalkIcon from '@material-ui/icons/PhoneInTalk';
import MailOutlineIcon from '@material-ui/icons/MailOutline';
import QueryBuilderIcon from '@material-ui/icons/QueryBuilder';

import styles from "assets/jss/material-kit-react/components/footerStyle.js";

const useStyles = makeStyles(styles);

export default function Footer(props) {
  const classes = useStyles();
  const { whiteFont } = props;
  const footerClasses = classNames({
    [classes.footer]: true,
    [classes.footerWhiteFont]: whiteFont
  });
  const aClasses = classNames({
    [classes.a]: true,
    [classes.footerWhiteFont]: whiteFont
  });

  return (<>
    <footer className={footerClasses} style={{backgroundColor: '#11322c',paddingTop: '30px'}}>
      <div className={classes.container}>
        <GridContainer>
          <GridItem id="footer1" xs={12} sm={6} md={4} lg={4} className={classes.footer_block} style={{marginBottom: 15}}>
            <div>
              <div style={{display: 'flex', justifyContent: 'flex-start'}}>
                <img style={{width: '50%', maxWidth: '173px', marginTop: 30}} id="logo_inferior" src={require("assets/img/logo_white.png")}/>
              </div>
            </div>
            <div className={classes.text}>
              <ul style={{paddingLeft: '0px', paddingTop: '30px'}}>
                <li style={{display: 'inline'}}><a style={{color: '#ffffff', textDecoration: 'underline', fontSize: '16px', fontWeight: 'bold', fontFamily: 'ITC Franklin Gothic Std Book'}} href="https://www.sadeco.es/contacto/">CONTACTA</a></li>
                <li style={{display: 'inline',marginLeft: '20px'}}><a style={{color: '#ffffff', textDecoration: 'underline', fontSize: '16px', fontWeight: 'bold', fontFamily: 'ITC Franklin Gothic Std Book'}} href="https://www.sadeco.es/que-puedes-hacer/participa-con-sadeco/">APP</a></li>
              </ul>
            </div>
          </GridItem>
          <GridItem id="footer2" xs={12} sm={6} md={4} lg={4} className={classes.footer_block} style={{marginBottom: 15}}>
            <div>
              <ul class="social-icons" style={{paddingLeft: '0px',paddingTop: '50px'}}>
               <li style={{textAlign: 'left',listStyle: 'none', display: 'inline'}}>
                  <a href="https://www.instagram.com/sadecocordoba/" class="icon">
                    <img style={{width: '18px', height: '18px'}} alt="instagram" src={require("assets/img/instagram-icon.png")}/>
                  </a>
                </li>

               <li style={{textAlign: 'left',listStyle: 'none', display: 'inline', marginLeft: '15px'}}>
                  <a href="https://www.facebook.com/sadeco.cordoba" class="icon">
                   <img style={{width: '18px', height: '18px'}} alt="facebook" src={require("assets/img/facebook-icon.png")}/>
                  </a>
                </li>

              <li style={{textAlign: 'left',listStyle: 'none', display: 'inline', marginLeft: '15px'}}>
                  <a href="https://twitter.com/sadecocordoba" class="icon">
                   <img style={{width: '18px', height: '18px'}} alt="twitter" src={require("assets/img/twitter-icon.png")}/>
                  </a>
                </li>
              <li style={{textAlign: 'left',listStyle: 'none', display: 'inline', marginLeft: '15px'}}>
                  <a href="https://www.youtube.com/user/CanalSadeco" class="icon">
                    <img style={{width: '18px', height: '18px'}} alt="youtube" src={require("assets/img/youtube-icon.png")}/>
                  </a>
                </li>
              <li style={{textAlign: 'left',listStyle: 'none', display: 'inline', marginLeft: '15px'}}>
                  <a href="https://www.tiktok.com/@sadeco_cordoba?" class="icon">
                    <img style={{width: '18px', height: '18px'}} alt="tiktok" src={require("assets/img/tiktok-icon.png")}/>
                  </a>
                </li>
              </ul>
            </div>
          </GridItem>

          <GridItem id="footer3" xs={12} sm={6} md={4} lg={4} className={classes.footer_block} style={{marginBottom: 15}}>
            <div style={{marginTop:'30px'}}>
              <p>
                <a style={{color: '#ffffff', textDecoration: 'none', fontSize: '16px', fontWeight: 'bold', fontFamily: 'ITC Franklin Gothic Std Book'}} href="tel+34957762000" title="Llamar a Sadeco">+34 957 76 20 00</a>
              </p>
              <p style={{fontFamily: 'ITC Franklin Gothic Std Book',color: '#ffffff', textDecoration: 'none', fontSize: '16px', fontWeight: 'normal'}}>
                Avda. Medina Azahara 4. 14005 Córdoba
              </p>
              <p>
                <a style={{color: '#ffffff', fontFamily: 'ITC Franklin Gothic Std Book', textDecoration: 'none', fontSize: '16px', fontWeight: 'bold'}} href="mailto:buzon@sadeco.es" title="Escribir a Sadeco">buzon@sadeco.es</a>
              </p>
            </div>
          </GridItem>
        </GridContainer>
      </div>
    </footer>
  </>);
}

Footer.propTypes = {
  whiteFont: PropTypes.bool
};
